export default {
  path: '/home',
  name: 'home',
  redirect: { name: 'home' },
  component: () =>
    import(/* webpackChunkName: "home" */ '@/views/home/index.vue'),
  children: [
    {
      path: '/home',
      name: 'home.welcome-page',
      component: () =>
        import(
          /* webpackChunkName: "welcome-home-page" */ '@/views/home/WelcomePage.vue'
        )
    }
  ]
}
